import { render } from "./NotificationCenterView.vue?vue&type=template&id=b4e11720&ts=true"
import script from "./NotificationCenterView.vue?vue&type=script&lang=ts"
export * from "./NotificationCenterView.vue?vue&type=script&lang=ts"

import "./NotificationCenterView.vue?vue&type=style&index=0&id=b4e11720&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__